import { SOURCE_SITE } from './constants';
import { getAttributionPayload } from './attribution';
import { getTrackingId } from './identity';
import { pushToDataLayer } from './gtm';

function isBrowser() {
  return typeof window !== 'undefined';
}

function sanitizePhoneNumber(phoneNumber) {
  if (!phoneNumber) return '';

  const italianPhoneRegex = /^\+39\d{9,10}$/;
  let normalized = String(phoneNumber).replace(/\s/g, '');

  if (!normalized.startsWith('+39')) {
    if (normalized.startsWith('+')) {
      return normalized;
    }

    if (normalized.startsWith('39') && (normalized.length === 11 || normalized.length === 12)) {
      normalized = `+${normalized}`;
    } else if (normalized.length === 9 || normalized.length === 10) {
      normalized = `+39${normalized}`;
    }
  }

  if (!italianPhoneRegex.test(normalized)) {
    return '';
  }

  return normalized;
}

function buildUserData({ email, phone, phoneNumber, firstName, lastName, first_name, last_name }) {
  const userData = {};
  const resolvedEmail = email;
  const resolvedPhone = sanitizePhoneNumber(phone || phoneNumber);
  const resolvedFirstName = firstName || first_name;
  const resolvedLastName = lastName || last_name;

  if (resolvedEmail) userData.email = resolvedEmail;
  if (resolvedPhone) userData.phone_number = resolvedPhone;

  const address = {};
  if (resolvedFirstName) address.first_name = resolvedFirstName;
  if (resolvedLastName) address.last_name = resolvedLastName;

  if (Object.keys(address).length > 0) {
    userData.address = address;
  }

  return userData;
}

function pushEvent(event, data = {}) {
  if (!isBrowser()) return;

  pushToDataLayer({
    event,
    lead_id: getTrackingId(),
    source_site: SOURCE_SITE,
    ...getAttributionPayload(),
    ...data,
  });
}

export function trackPageView(previousUrl) {
  if (!isBrowser()) return;

  pushEvent('page_view', {
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_title: document.title,
    page_referrer: previousUrl || document.referrer || undefined,
  });
}

export function trackClickCta(ctaScope, ctaPosition) {
  pushEvent('click_cta', {
    cta_scope: ctaScope,
    cta_position: ctaPosition,
  });
}

export function mapCourseType(categories, degreeType) {
  const value = (categories || degreeType || '').toLowerCase();

  if (value.includes('non') && value.includes('so')) return 'non-so';
  if (
    value.includes('professional') ||
    value.includes('formazione') ||
    value.includes('corso') ||
    value.includes('ai') ||
    value.includes('cs') ||
    value.includes('pm') ||
    value.includes('fullstack') ||
    value.includes('amministrativ')
  ) {
    return 'professionalizzante';
  }
  if (
    value.includes('laurea') ||
    value.includes('triennale') ||
    value.includes('magistrale') ||
    value.includes('ciclo') ||
    value.includes('universit')
  ) {
    return 'laurea';
  }

  return 'professionalizzante';
}

export function trackGenerateLead({ leadSource = 'comparatore', courseType, userData }) {
  pushEvent('generate_lead', {
    lead_source: leadSource,
    course_type: courseType,
    user_data: buildUserData(userData),
  });
}

export function trackBookCall(userData) {
  pushEvent('book_call', {
    user_data: buildUserData(userData),
  });
}

export function trackLeadError(leadTypeError, leadSource = 'comparatore') {
  pushEvent('lead_error', {
    lead_type_error: String(leadTypeError),
    lead_source: leadSource,
  });
}

export function trackSelectProposal() {
  pushEvent('select_proposal');
}

export function trackClickInfoProposal() {
  pushEvent('click_info_proposal');
}

export function handleCourseInfoToggle(cardIndex, setActiveIndex) {
  setActiveIndex((prev) => {
    if (prev !== cardIndex) {
      trackClickInfoProposal();
    }
    return prev === cardIndex ? null : cardIndex;
  });
}

export function trackContact(contactSource = 'comparatore') {
  pushEvent('contact', {
    contact_source: contactSource,
  });
}
